<template>
  <div class="box" ref="fullscreenContainer">
    <!--    @click="enterFullscreen"-->
    <!--    <div id="myButton" @click="enterFullscreen" v-show="false"></div>-->
    <!-- 第一行 试卷名称 -->
    <div class="top-box">
      <div class="box-head-one">
        {{
          "石家庄市国资委系统公文写作技能大赛决赛(" +
          testPaper.testpaperName.replace(/[AB]/g, "") +
          ")"
        }}
      </div>
      <div class="box-head-two">
        <!-- 准考证号 -->
        <div class="box-head-two-name">
          准考证号：{{ this.examRegisterNumber }}
        </div>
        <!-- 考生姓名 -->
        <div class="box-head-two-name">考生姓名：{{ this.userName }}</div>
        <div class="box-head-two-name">身份证号：{{ this.identityCard }}</div>
      </div>
    </div>
    <!-- 第二行 考生照片 考生试题顺序 考生试题 字体加减 -->
    <div class="center-box">
      <div class="options-box">
        <!-- 左侧题目列表 -->
        <div v-if="radioSubjectType != 0">
          <div class="title">单项选择题</div>
          <!-- <div class="score-particulars">（本大题共120小题，每小题0.5分，共60分；在每小题的四个备选答案中，选出一个正确答案。错选、多选或未选均无分。）</div> -->
          <div class="topic-item">
            <div
              :class="{
                active: item.isOk || `radio-${index}` === currentActive,
              }"
              v-for="(item, index) in radio"
              :key="`radio-${index}`"
              @click="handle(item, `radio-${index}`)"
            >
              {{ index + 1 }}
            </div>
          </div>
        </div>
        <div v-if="checkSubjectType != 0">
          <div class="title">多项选择题</div>
          <!-- <div class="score-particulars"></div> -->
          <div class="topic-item">
            <div
              :class="{
                active: item.isOk || `check-${index}` === currentActive,
              }"
              v-for="(item, index) in check"
              :key="`check-${index}`"
              @click="handle(item, `check-${index}`)"
            >
              {{ index + 1 }}
            </div>
          </div>
        </div>
        <!-- 左侧题目列表 -->
        <div v-if="articleSubjectType !== 0">
          <div class="title">文章题目</div>
          <!-- <div class="score-particulars">（本大题共120小题，每小题0.5分，共60分；在每小题的四个备选答案中，选出一个正确答案。错选、多选或未选均无分。）</div> -->
          <div class="topic-item">
            <div
              :class="{
                active: item.isOk || `textarea-${index}` === currentActive,
              }"
              v-for="(item, index) in textarea"
              :key="`textarea-${index}`"
              @click="handle(item, `textarea-${index}`)"
            >
              {{ index + 1 }}
            </div>
          </div>
          <div
            class="comment"
            style="padding: 0 10px"
            v-html="mainExam.comment"
          ></div>
        </div>
      </div>
      <!-- 中间题目详情 -->
      <div class="topic-box">
        <!-- 单选 -->
        <template v-for="(item, index) in radio">
          <topic-radio
            ref="paper"
            v-if="currentActive === `radio-${index}`"
            :key="`radio-content-${index}`"
            :RadioNum="index + 1"
            :RadioContent="item.subjectName"
            :redioList="JSON.parse(item.optionConf)"
            :data-id="item.subjectId"
            :currentAnswer="item.currentAnswer"
            :font-size="fontSize"
            @change="handleChange"
          ></topic-radio>
        </template>
        <!-- 多选 -->
        <template v-for="(item, index) in check">
          <topic-check
            ref="paper"
            v-if="currentActive === `check-${index}`"
            :key="`check-content-${index}`"
            :CheckNum="index + 1"
            :CheckContent="item.subjectName"
            :CheckList="JSON.parse(item.optionConf)"
            :data-id="item.subjectId"
            :currentAnswer="item.currentAnswer"
            :font-size="fontSize"
            @change="handleChange"
          ></topic-check>
        </template>
        <!-- 文章题 -->
        <template v-for="(item, index) in textarea">
          <topic-article
            ref="paper"
            v-if="currentActive === `textarea-${index}`"
            :key="`textarea-${index}`"
            :TextareaNum="index + 1"
            :TextareaContent="item.subjectName"
            :TextareaList="JSON.parse(item.optionConf)"
            :data-id="item.subjectId"
            :currentAnswer="item.currentAnswer"
            @change="handleChange"
            @remove="fileRemove"
          ></topic-article>
        </template>
      </div>
      <div class="topic-right">
        <!-- 考生照片 -->
        <div class="user-img">
          <img :src="this.photograph" width="130px" height="160px" />
        </div>
        <!-- 剩余时间 -->
        <div class="surplus-time">
          <div class="surplus-time-top">剩余时间</div>
          <div class="surplus-time-color">
            {{ pad(hours) }}:{{ pad(remainingMinutes) }}:{{ pad(seconds) }}
          </div>
          <div class="surplus-time-line"></div>
          <!-- 进度条 -->
          <div class="progress-box">
            <div class="surplus-time-top">答题进度</div>
            <div class="bar-info">
              {{ isAnswer }} / {{ subjectList.length }}
            </div>
            <div class="bar"></div>
            <div
              class="slider"
              :style="{ width: progressPercentage + '%' }"
            ></div>
          </div>
          <div class="surplus-time-line"></div>
          <div class="topic-padding">
            <div class="topic-up" @click="backTopic">上一题</div>
            <div class="topic-below" @click="nextTopic">下一题</div>
          </div>
        </div>
        <div class="submit-buuton">
          <el-button type="primary" @click="submitText">提交试卷</el-button>
        </div>
        <!-- <div class="logo-text-ui">测试屏幕大小文字</div> -->
      </div>
    </div>
  </div>
</template>
<script>
import TopicArticle from "@/components/topicArticle.vue";
import TopicRadio from "@/components/topicRadio.vue";
import TopicCheck from "@/components/topicCheck.vue";


export default {
  components: {
    TopicRadio,
    TopicCheck,
    TopicArticle,
  },
  data() {
    return {
      paperId: "",
      testPaper: {},
      examRegisterNumber: "",
      mainId: "",
      mainExam: {},
      examId: "",
      examination: {},
      userName: "",
      examRegistrationNumber: "",
      identityCard: "",
      photograph: "",
      hours: 0,
      remainingMinutes: 0,
      seconds: 0,
      currentActive: `radio-0`, //已做未做
      articleList: [], //文章
      RadioContent: "", // 单选

      articleNum: 1, //文章
      articleContent: 1, //文章

      radio: [], // 单选题
      check: [], // 多选题
      textarea: [], // 文章题

      radioSubjectType: 0, // 单选题个数
      checkSubjectType: 0, // 多选题个数
      articleSubjectType: 0, //文章类型题目

      intervalId: null,
      subjectList: [], // 题目个数
      isAnswer: 0,
      illegalOperateCount: 0,
      illegalOperateTimer: null,
      isPageVisible: false,
      isModalVisible: false,
      poupContent: "",
      countDown: 20,
      poupConfirmShow: true,

      fontSize: 16,
    };
  },
  computed: {
    // 进度条
    progressPercentage() {
      return (this.isAnswer / this.subjectList.length) * 100;
    },
  },
  updated() {
    this.$nextTick(() => {
      const elements = this.$el.querySelectorAll("span");
      elements.forEach((el) => {
        el.style.fontSize = "14px";
      });
    });
  },
  created() {
    if (
      this.$route.query.examId &&
      this.$route.query.mainId &&
      this.$route.query.paperId
    ) {
      this.examId = this.$route.query.examId;
      this.mainId = this.$route.query.mainId;
      this.paperId = this.$route.query.paperId;
      this.getExaminationDetail();
      this.getMainExaminationDetail();
      this.getStartExamination();
    }
    this.selectUser();
  },

  mounted() {},
  beforeDestroy() {
    this.stopCountdown();
  },

  methods: {
    getMainExaminationDetail() {
      let _this = this;
      let parmas = {
        examinationId: _this.mainId,
      };
      _this.$api.articleExam
        .getArticleExaminationDetail(parmas)
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            _this.mainExam = res.data;
          }
        })
        .catch(() => {});
    },
    fileRemove(data) {
      const objChoiceOne = this.subjectList.find(
        (item) => item.subjectId == data.dataId
      );
      objChoiceOne.isOk = false;
      objChoiceOne.currentAnswer = data.answer;
      this.isAnswer = this.subjectList.filter((item) => item.isOk).length;
      let params = {
        examinationId: this.examId,
        subjectId: data.dataId,
        examArticleId: this.mainId,
      };
      this.$api.articleExam.removeAnswer(params);
    },
    handleChange(data) {
      // 单选 多选 判断 主观
      const objChoiceOne = this.subjectList.find(
        (item) => item.subjectId == data.dataId
      );
      console.log("handleChange", objChoiceOne);
      if (data.answer !== null && data.answer.length > 0) {
        objChoiceOne.isOk = true;
        objChoiceOne.currentAnswer = data.answer;
        this.isAnswer = this.subjectList.filter((item) => item.isOk).length;
      }
      let params = {
        examArticleId: this.mainId,
        examId: this.examId,
        subjectId: data.dataId.toString(),
        answer: Array.isArray(data.answer)
          ? data.answer.toString()
          : data.answer,
        type: "examination",
      };
      this.$api.articleExam.answerArticleProcess(params).then((res) => {
        if (res.code !== 200) {
          this.$message({
            message: "出错了!请联系监考人员",
            type: "warning",
          });
        }
      });
    },
    // 获取考试详情
    getExaminationDetail() {
      let _this = this;
      let parmas = {
        examinationId: _this.examId,
      };
      _this.$api.text.getExaminationDetail(parmas).then((res) => {
        if (res.code == 200) {
          _this.examination = res.data;
          _this.convertMinutesToHHMMSS(_this.examination.minute);
        }
      });
    },
    // 查询考试页面考生信息
    selectUser() {
      this.$api.text.selectUserMessage().then((response) => {
        this.userName = response.data.name;
        // this.examRegistrationNumber = response.data.examRegistrationNumber;
        this.identityCard = response.data.cardNum;
        this.photograph = response.data.headUrl;
      });
    },
    // 选中样式
    handle(item, key) {
      this.currentActive = key;
    },
    // 时间补0
    pad(value) {
      return value.toString().padStart(2, "0");
    },
    // 强制提交
    stopText() {
      setTimeout(function () {
        this.$message({
          message: "考试已结束",
          type: "warning",
        });
        this.$router.push({
          name: "examResult",
        });
      }, 30 * 60 * 1000);
    },
    // 交卷
    submitText() {
      const notOk = [];
      this.subjectList.forEach((item) => {
        if (!item.isOk) {
          notOk.push(item);
        }
      });
      if (notOk.length) {
        this.$message({
          message: "仍有题目未完成，不可提交",
          type: "warning",
        });
      } else {
        if (this.hours === 0 && this.remainingMinutes <= 60) {
          this.$message({
            message: "交卷成功",
            type: "success",
          });
          this.$router.push({
            name: "examResult",
          });
        } else {
          this.$message({
            message: "距考试结束60分钟方可交卷",
            type: "warning",
          });
        }
      }
    },
    // 时分秒转换
    convertMinutesToHHMMSS(minutes) {
      this.hours = Math.floor(minutes / 60);
      this.remainingMinutes = minutes % 60;
      this.seconds = Math.floor((minutes * 60) % 60);

      return this.hours + this.remainingMinutes + this.seconds;
    },
    formatSeconds(value) {
      let secondTime = parseInt(value);
      let minuteTime = 0;
      let hoursTime = 0;
      if (secondTime > 60) {
        minuteTime = parseInt(secondTime / 60);
        secondTime = parseInt(secondTime % 60);
        if (minuteTime > 60) {
          hoursTime = parseInt(minuteTime / 60);
          minuteTime = parseInt(minuteTime % 60);
        }
      }
      this.hours = hoursTime;
      this.remainingMinutes = minuteTime;
      this.seconds = secondTime;
      //喀什倒计时
      this.startCountdown();
    },
    // 倒计时
    startCountdown() {
      this.intervalId = setInterval(() => {
        this.updateCountdown();
      }, 1000);
    },
    // 倒计时结束
    stopCountdown() {
      clearInterval(this.intervalId);
    },
    // 更新倒计时
    updateCountdown() {
      if (this.hours > 0 || this.remainingMinutes > 0 || this.seconds > 0) {
        if (this.remainingMinutes === 0 && this.seconds === 0) {
          this.hours--;
          this.remainingMinutes = 59;
          this.seconds = 59;
        } else if (this.seconds === 0) {
          this.remainingMinutes--;
          this.seconds = 59;
        } else {
          this.seconds--;
        }
      } else {
        this.stopCountdown();
        this.stopText();
      }
    },
    // 上一题
    backTopic() {
      let arr = this.currentActive.split("-");
      let key = arr[0];
      let index = parseInt(arr[1]);
      index--;
      if (index <= -1) {
        const topicmap = ["radio",
          "check",
          "textarea"];
        let topindex = topicmap.indexOf(key);
        if (topindex == 0) {
          this.$message({
            message: "没有上一题了",
            type: "warning",
          });
          return;
        }
        this.currentActive =
          topicmap[topindex - 1] +
          "-" +
          (this[topicmap[topindex - 1]].length - 1);
      } else {
        this.currentActive = key + "-" + index;
      }
    },
    // 下一题
    nextTopic() {
      let arr = this.currentActive.split("-");
      let key = arr[0];
      let index = parseInt(arr[1]);
      index++;
      if (this[key].length == index || this[key].length < index) {
        const topicmap = [
          "radio",
          "check",
          "textarea",
        ];
        let topindex = topicmap.indexOf(key);
        if (topindex == 2) {
          this.$message({
            message: "没有下一题了",
            type: "warning",
          });
          return;
        }
        this.currentActive = topicmap[topindex + 1] + "-" + 0;
      } else {
        this.currentActive = key + "-" + index;
      }
    },
    // 获取题目
    getStartExamination() {
      let _this = this;
      let parmas = {
        testpaperId: _this.paperId,
        examinationId: _this.examId,
        type: 2,
      };
      _this.$api.articleExam.getStartArticleExamination(parmas).then((res) => {
        if (res.code != 200) {
          this.$message({
            message: res.msg,
            type: "warning",
          });
          let timer = setTimeout(() => {
            this.$router.go(-1);
          }, 1000);

          return;
        }
        console.log("res", res);
        _this.testPaper = res.data.testPaper;
        _this.examRegisterNumber = res.data.examRegisterNumber;
        res.data.testPaper.subjectItems.forEach((item) => {
          if (item.subjectType === 7) {
            this.articleSubjectType++;
          } else if (item.subjectType == 0) {
            this.radioSubjectType++;
          } else if (item.subjectType == 1) {
            this.checkSubjectType++;
          }
        });
        if (res.code === 200) {
          _this.subjectList = res.data.testPaper.subjectItems;
          _this.subjectList.forEach(function (item) {
            item.isOk = false; //当前是否已做
            item.isActive = false; //当前是否选中
            if (item.subjectType === 7) {
              _this.textarea.push(item);
            } else if (item.subjectType == 0) {
              _this.radio.push(item);
            } else if (item.subjectType == 1) {
              _this.check.push(item);
            }
          });

          const userAnswer = res.data.userAnswer;
          if (userAnswer instanceof Array && userAnswer.length > 0) {
            userAnswer.forEach((item) => {
              const obj = _this.subjectList.find(
                (val) => val.subjectId === item.subjectId
              );
              console.log(obj);
              if (obj.subjectType === 7) {
                // 单选、多选、判断或主观题的处理
                obj.isOk = true;
                obj.currentAnswer = item.answer;
                _this.isAnswer++;
              } else {
                // 单选、多选、判断或主观题的处理
                obj.isOk = true;
                // obj.currentAnswer = item.answer;
                if (obj.subjectType === 1) {
                  // 多选题
                  obj.currentAnswer = item.answer
                    .split(",")
                    .map((answer) => answer.trim());
                } else {
                  obj.currentAnswer = item.answer;
                }
                _this.isAnswer++;
              }
            });
          }
          this.seconds = res.data.minute * 60;
          _this.formatSeconds(this.seconds);
        }
      });
    },
  },
};
</script>

<style scoped>
.comment {
  & >>> span {
    /* >>> 在面对scss的时候会导致样式穿透失效 */
    font-size: 14px !important;
  }
}

.box {
  padding: 10px;
  height: 100vh;
  width: 100%;
  flex-direction: column;
  display: flex;
  background-color: rgb(239, 243, 247);
}

.top-box {
  left: 10px;
  right: 10px;
  height: 100px;
  color: rgb(255, 255, 255);
  background-color: rgb(64, 112, 179);
}

.box-head-one {
  font-size: 30px;
  /** 试卷题目字体大小 */
  line-height: 100px;
  float: left;
  margin-left: 15px;
}

.box-head-two {
  float: right;
  font-size: 18px;
  /** 考试姓名 准考证号 字体大小 */
}

.box-head-two-name {
  height: 35px;
  line-height: 35px;
  width: 300px;
  color: rgb(255, 255, 255);
}

.box .center-box {
  margin-top: 15px;
  /* width: 100%; */
  align-items: stretch;
  height: 80vh;
}

.options-box {
  /* width: 10%; */
  float: left;
  height: 100%;
  overflow-y: auto;
}

.center-box .options-box {
  width: 15%;
  background: rgb(255, 255, 255);
  overflow-y: auto;
}

.options-box .slide {
  /* width: 100%; */
  height: 24px;
  display: flex;
  justify-content: flex-end;
  margin: 8px 0px;
}

.options-box .slide img {
  width: 24px;
  /* height: 100%; */
  cursor: pointer;
}

.options-box .title {
  /* width: 100%; */
  height: 30px;
  font-weight: bold;
  box-sizing: border-box;
  border-radius: 15px;
  text-align: left;
  padding-left: 10px;
  line-height: 30px;
  color: rgb(0, 0, 0);
  font-family: 思源黑体;
  font-size: 16px;
  /** 单线选择题字体大小 */
}

.options-box .topic-item {
  justify-content: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  /* width: 100%; */
  padding: 10px 17px;
  box-sizing: border-box;
  gap: 25px;
}

.options-box .topic-item div.active {
  background: rgb(64, 112, 179);
  color: rgb(255, 255, 255);
}

.options-box .topic-item div {
  width: 35px;
  height: 35px;
  box-sizing: border-box;
  cursor: pointer;
  background: rgb(242, 249, 255);
  border: 1px solid rgb(64, 112, 179);
  border-radius: 8px;
  color: rgb(0, 0, 0);
  font-family: 思源黑体;
  font-size: 16px;
  /** 题目序号字体大小 */
  text-align: center;
  line-height: 35px;
}

.topic-box {
  float: left;
  width: 68%;
  padding: 26px 29px;
  overflow-y: auto;
  height: 100%;
  background-color: rgb(255, 255, 255);
  margin-left: 15px;
}

.topic-right {
  text-align: center;
  float: right;
  width: 15%;
}

.surplus-time {
  text-align: center;
  justify-content: center;
  margin: 0 auto;
  margin-top: 15px;
  width: 75%;
  /* height: 300px; */
  background-color: rgb(255, 255, 255);
}

.surplus-time-top {
  padding-top: 15px;
  font-size: 18px;
  /** 剩余时间 答题进度 字体大小 */
  font-weight: bold;
}

.surplus-time-color {
  color: red;
  font-family: 思源黑体;
  font-size: 22px;
  /** 剩余时间字体大小 */
}

.surplus-time-line {
  margin-top: 10px;
  border: 1px solid rgb(235, 238, 246);
}

.progress-box {
  width: 100%;
  position: relative;
  margin-right: 100px;
}

.progress-box .bar {
  height: 10px;
  position: absolute;
  background: rgba(124, 132, 139);
  opacity: 0.4;
  border-radius: 1px;
}

.progress-box .slider {
  height: 10px;
  background: rgb(64, 112, 179);
  top: 0;
}

.progress-box .bar-info {
  color: red;
  font-family: 思源黑体;
  font-size: 22px;
  /** 答题进度字体大小 */
  text-align: center;
}

.topic-padding {
  padding: 15px;
}

.topic-up {
  margin: 0 auto;
  width: 110px;
  height: 50px;
  line-height: 50px;
  background: rgb(64, 112, 179);
  color: rgb(255, 255, 255);
  border-radius: 15px;
  font-size: 18px;
  cursor: pointer;
}

.topic-below {
  margin: 0 auto;
  width: 110px;
  height: 50px;
  line-height: 50px;
  background: rgb(64, 112, 179);
  color: rgb(255, 255, 255);
  border-radius: 15px;
  font-size: 18px;
  margin-top: 15px;
  cursor: pointer;
}

.topic-right .submit-buuton {
  margin-top: 25px;
}

.score-particulars {
  font-weight: bold;
}

.custom-modal {
  padding-top: 100px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  /* align-items: center; */
  align-items: flex-start;
  z-index: 9999; /* 确保在最上层 */
}

.modal-header {
  display: flex;
  color: red;
  font-size: 20px;
  justify-content: center;
}

.modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  max-width: 80%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.modal-footer {
  text-align: center;
  border: none;
  padding-bottom: 20px;
  padding-top: 0;
}

.btn {
  width: 100px;
  height: 34px;
  padding: 0;
  line-height: 32px;
}

.btn-gray {
  background: #f2f2f2;
  border: 1px solid #f2f2f2;
  color: #666666;
}

/* .logo-text-ui {
  font-size: calc(100vw * 24 / 1920);
}
@media screen and (min-width: 1000px) and (max-width: 1200px) {
  .logo-text-ui {
    font-size: 17px;
    top: 24% !important;
    letter-spacing: 2px;
  }
}
@media screen and (min-width: 1280px) and (max-width: 1360px) {
  .logo-text-ui {
    font-size: 23px;
    top: 24% !important;
    letter-spacing: 2px;
  }
}
@media screen and (min-width: 1360px) and (max-width: 1366px) {
  .logo-text-ui {
    font-size: 24px;
    top: 18% !important;
    letter-spacing: 2px;
  }
}
@media screen and (min-width: 1366px) and (max-width: 1400px) {
  .logo-text-ui {
    font-size: 24px;
    top: 18% !important;
    letter-spacing: 2px;
  }
}
@media screen and (min-width: 1400px) and (max-width: 1440px) {
  .logo-text-ui {
    font-size: 26px;
    top: 24% !important;
    letter-spacing: 2px;
  }
}

@media screen and (min-width: 1440px) and (max-width: 1600px) {
  .logo-text-ui {
    font-size: 26px;
    top: 10% !important;
    letter-spacing: 1px;
  }
}
@media screen and (min-width: 1600px) and (max-width: 1680px) {
  .logo-text-ui {
    font-size: 29px;
    top: 15% !important;
    letter-spacing: 2px;
  }
}
@media screen and (min-width: 1680px) and (max-width: 1920px) {
  .logo-text-ui {
    font-size: 32px;
    top: 7% !important;
    letter-spacing: 1px;
  }
}

@media screen and (min-width: 1920px) {
  .logo-text-ui {
    font-size: 36px;
    top: 10% !important;
    letter-spacing: 2px;
  }
} */
</style>



// WEBPACK FOOTER //
// src/view/articleExam/text.vue